export interface FetchPublicWabunkaApiArgs<T> {
  path: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: object;
  query?: Record<string, string>;
  converter: (res: unknown) => T;
}

/**
 * Public Wabunka API への $fetch ラッパー
 * useFetch と異なり onMounted 内の非同期処理やリトライループでも使用できる
 * ページ層では直接使用せず、ドメイン知識を有した Composable を介して利用してください
 *
 * @throws $fetch のエラーがそのまま throw されます。呼び出し元で適切にハンドリングしてください。
 */
export const fetchPublicWabunkaApi = async <T>({ path, method = 'GET', body, query, converter }: FetchPublicWabunkaApiArgs<T>): Promise<T> => {
  const config = useRuntimeConfig();
  const baseUrl = config.public.WABUNKA_PUBLIC_API_BASE_URL as string;

  const raw = await $fetch(path, {
    method,
    baseURL: baseUrl,
    headers: {
      // eslint-disable-next-line
      'Content-Type': 'application/json',
      Accept: 'application/json',
      // consumer は訪日客向けのため、backend のローカライズ（エラー文言・表示名）を常に英語で取得する
      // eslint-disable-next-line
      'X-Wabunka-Language': 'en',
    },
    ...(body !== undefined ? { body } : {}),
    ...(query !== undefined ? { query } : {}),
  });

  return converter(raw);
};
